import React,{useEffect,useState,useContext} from 'react'
import { Link } from "react-router-dom";
import ResumeCard from '../../components/ResumeCard/index.js'
import {AiFillFileAdd} from 'react-icons/ai'
import {Container,Row,Col} from 'react-bootstrap'
import axios from 'axios'
import Loading from '../../components/Loading/index.js'
import LoadingFailed from '../../components/LoadingFailed/index.js'
import EmptyList from '../../components/EmptyList/index.js'
import { v4 as uuidv4 } from 'uuid';
import AuthContext from '../../context/AuthContext.js'
import PrefixContext from '../../context/PrefixContext.js';


import Template1 from '../../resumes/t1/index.js'
import Template2 from '../../resumes/t2/index.js'


function Index() {
    
    const AuthContextData = useContext(AuthContext);
    const PrefixContextData = useContext(PrefixContext);
    const [resumes, setresumes] = useState()
    const [loading, setloading] = useState('LOADING')

    const getResumeList = async () => {
        let token = localStorage.getItem('auth-token');
        axios.defaults.headers.common['Authorization'] = token;
        axios.get(PrefixContextData.prefixUrl+'data/resumes')
            .then(response => {
                if(response.status === 200){
                    setloading('LOADED');
                    setresumes(response.data);
                }
                else{
                    setloading('FAILED');
                }
            })
            .catch(error => {
                if(error.response!==undefined){
                    if(error.response.status === 401){
                        AuthContextData.logout()
                    }
                }
                setloading('FAILED');
            });
    }

    useEffect(() => {
        getResumeList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    
    return (
        <>
        <section className="page-heading-margin bg-secondary">
            <Container>
                <Row className="mt-4 mt-md-4">
                    <Col md={{ size:6,order: 2 }}>
                        <div className="d-md-flex justify-content-end">
                            <Link to="/resume/add" className="d-inline-block border border-primary py-2 px-3 btn-primary">
                                <AiFillFileAdd />
                                <span> Add Resume</span>
                            </Link>
                        </div>
                    </Col>
                    <Col className="my-3 my-md-0" md={{ size:6,order: 1 }}>
                        <h4>Saved Resumes</h4>
                        <p>All you resumes will be shown here.</p>
                    </Col>
                </Row>
                {loading === 'LOADING' && <Loading type="withImage" />}
                {loading === 'FAILED' && <LoadingFailed type="withImage" />}
                {
                    (loading === 'LOADED' &&  (resumes !== undefined && Array.isArray(resumes) && resumes.length === 0)) && 
                    <EmptyList type="withImage" label="No Saved Resumes Found."/>
                }
                {
                    (loading === 'LOADED' &&  (resumes !== undefined && Array.isArray(resumes) && resumes.length !== 0)) &&
                    <>
                        <div className="d-flex flex-wrap resumeList">
                        {
                            resumes.map((el)=>{
                                if(el.template_id !== undefined && el.template_id.identity !== undefined)
                                {
                                    if(el.template_id.identity === "TemplateOne"){
                                        return <ResumeCard key={uuidv4()} handlerId={el._id}>
                                                <Template1 {...el} size="small"/>
                                            </ResumeCard>
                                    }
                                    else if(el.template_id.identity === "TemplateTwo"){
                                        return <ResumeCard key={uuidv4()} handlerId={el._id}>
                                                <Template2 {...el} size="small"/>
                                            </ResumeCard>
                                    }
                                    else{
                                        return null;
                                    }
                                }
                                else{
                                    return null;
                                }
                            })
                        }
                        </div>
                    </>
                }
            </Container>
        </section>
        </>
    )
}

export default Index
